import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { DetailInboxPage } from './detail-inbox/detail-inbox.page';

@Component({
  selector: 'app-tab3',
  templateUrl: 'tab-inbox.page.html',
  styleUrls: ['tab-inbox.page.scss']
})
export class TabInboxPage {
	inbox: string = 'surat';

	constructor(private modalCtrl:ModalController, private navCtrl:NavController) { }

  ngOnInit() {
  }

  async modalInbox() {
    const modal = await this.modalCtrl.create({
      component: DetailInboxPage,
    });
    return await modal.present();
  }

}
